module.exports = __webpack_public_path__ + "static/durham-logo-9f0944599002047028d9f7281847856c.png";